import React from "react";
import { Link } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import logo from "../Assets/Img/logo.png";
import logoServizi from "../Assets/Img/logoServizi.png";

function Footer(props) {
  return (
    <footer className="it-footer">
      <div className="it-footer-main footerCustom">
        <div className="container footerText">
          <section>
            <div className="row">
              <div className="col-sm-6">
                <div className="it-brand-wrapper">
                  <a className="">
                    <img alt="logo" height="100" width="100" src={logo} />
                    <div className="it-brand-text">
                      <h2 className="no_toc">Comune di Bari</h2>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="it-brand-wrapper float-sm-right">
                  <a href="https://servizilocalispa.com/" target="_blank">
                    <img alt="logo" height="95" width="200" src={logoServizi} />
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section></section>
          <section className="py-4">
            <div className="row clearfix">
              <div className="col-lg-12 col-md-4 pb-2">
                <h6>CONTATTI E INFORMAZIONI</h6>
                <p>
                Comune di Bari Ripartizione Servizi alla Persona Largo Chiurlia n. 27 | 70122 Bari  | Italy
                  <br />
                  <strong>Email</strong> smartwelfare@comune.bari.it o  serviziallapersona.bari@servizilocalispa.it
                  <br />
                  <strong>Telefono</strong> 080.8407737 nei giorni di Lunedì, Mercoledì e Venerdì dalle ore 09:00 alle ore 13:00 <br/>e nella giornata del Giovedì dalle ore 15:00 alle ore 18:00.


                  <br />
                  CF: 80015010723 - P.IVA: 00268080728
                  <br />
                  Per l'elenco delle PEC: Indice delle Pubbliche Amministrazioni
                  <br />
                </p>
              </div>
              {/* <div className="col-lg-3 col-md-4 pb-2">
                <h6>SOCIAL</h6>
                <p>
                  <a
                    target="_blank"
                    href="https://it.linkedin.com/company/servizi-locali-spa"
                  >
                    <svg className="icon icon-white borderCircle">
                      <use href={`${iconSprite}#it-linkedin`} />
                    </svg>
                  </a>
                </p>
                <p>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/servizilocalispa.it"
                  >
                    <svg className="icon icon-white borderCircle">
                      <use href={`${iconSprite}#it-facebook`} />
                    </svg>
                  </a>
                </p>
              </div> */}
            </div>
          </section>

          <section className="py-2 border-white border-top">
            <div className="row clearfix">
              <div className="col-lg-4 py-2">
                <h3 className="sr-only">Sezione Link Utili</h3>
                <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
                  <li className="list-inline-item">
                    <a
                      href="https://www.comune.bari.it/privacy"
                      className="small-prints text-white"
                      title="Privacy-Cookies"
                      target="_blank"
                    >
                      Privacy policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <div className="row">
            <div className="col-12 text-center">
              <p>
                Powered by Servizi Locali S.P.A. • Copyright © 2022 • All rights
                reserved.
              </p>
            </div>
          </div>
          <div className="cookiebar">
            <p>
              Questo sito utilizza solo cookie tecnici. <br />
              Per maggiori informazioni consulta la nostra Privacy Policy.
            </p>
            <div className="cookiebar-buttons">
              <a
                href="https://www.comune.bari.it/privacy"
                target="_blank"
                className="cookiebar-btn"
              >
                Privacy policy<span className="sr-only">cookies</span>
              </a>
              <button
                data-accept="cookiebar"
                className="cookiebar-btn cookiebar-confirm"
              >
                Accetto<span className="sr-only"> i cookies</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
export const MemoizedFooter = React.memo(Footer);
